import { useMemo } from "react";
import { formatTRY } from "@/lib/apiClient";
import { Trophy } from "lucide-react";

export const TopProducts = ({ sales, n = 20 }) => {
  const top = useMemo(() => {
    const agg = {};
    for (const s of sales) for (const it of s.items) {
      const p = agg[it.product_name] || (agg[it.product_name] = { qty: 0, total: 0 });
      p.qty += it.quantity; p.total += it.line_total || 0;
    }
    return Object.entries(agg).map(([name, v]) => ({ name, ...v })).sort((a, b) => b.qty - a.qty).slice(0, n);
  }, [sales, n]);
  const max = top[0]?.qty || 1;

  return (
    <div className="rounded-xl border border-border bg-card p-5" data-testid="top-products">
      <h3 className="flex items-center gap-2 font-heading text-lg font-semibold"><Trophy className="h-5 w-5 text-primary" /> En Çok Satan Ürünler <span className="text-xs font-normal text-muted-foreground">ilk {n}</span></h3>
      {top.length === 0 && <p className="mt-4 text-sm text-muted-foreground">Satış yok</p>}
      <div className="mt-4 grid gap-x-8 gap-y-1.5 md:grid-cols-2">
        {top.map((p, i) => (
          <div key={p.name} className="relative overflow-hidden rounded-lg px-3 py-1.5" data-testid={`top-product-${i + 1}`}>
            <div className="absolute inset-y-0 left-0 bg-primary/10" style={{ width: `${(p.qty / max) * 100}%` }} />
            <div className="relative flex items-center justify-between gap-3 text-sm">
              <span className="flex min-w-0 items-center gap-2"><span className="w-6 shrink-0 font-mono text-xs text-muted-foreground">{i + 1}.</span><span className="truncate font-medium">{p.name}</span></span>
              <span className="shrink-0 text-right"><b className="font-mono">{p.qty}</b> <span className="text-xs text-muted-foreground">adet · {formatTRY(p.total)}</span></span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
